import * as Highcharts from 'highcharts';

import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { KlaDataService } from './kla.data.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class HighchartsService {
  constructor(private dataService: KlaDataService, @Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId) && navigator.userAgent) {
      this.initModules();
    }
  }

  initModules() {
    // Highcharts 12+ modules register themselves when loaded and crash without a
    // window, so they are required here (browser only) instead of imported at the top.
    (window as any)._Highcharts = require('highcharts');
    require('highcharts/highcharts-3d');
    require('highcharts/highcharts-more');
    require('highcharts/modules/wordcloud');
    require('highcharts/modules/solid-gauge');
    require('highcharts/modules/series-label');
    require('highcharts/modules/exporting');
    require('highcharts/modules/export-data');
    require('highcharts/modules/accessibility');
    require('highcharts/modules/data');
    require('highcharts/modules/venn');
    require('highcharts/modules/streamgraph');

    // Highcharts' accessibility module adds a focusable "exit anchor" div
    // (.highcharts-exit-anchor) to let keyboard users leave the chart, but
    // never gives it a role, which fails "focusable elements must have a role".
    Highcharts.addEvent(Highcharts.Chart as any, 'render', function(this: Highcharts.Chart) {
      const exitAnchor = this.container?.parentElement?.querySelector('.highcharts-exit-anchor');
      if (exitAnchor && !exitAnchor.hasAttribute('role')) {
        exitAnchor.setAttribute('role', 'text');
      }
    });

    // The exporting module can no longer be left out per tenant - toggle its visibility instead.
    Highcharts.setOptions({
      exporting: {
        enabled: !!this.dataService.HIGHCHARTS_EXPORT_STATUS,
        buttons: {
          contextButton: {
            menuItems: [
              'viewFullscreen', 'printChart', 'separator',
              'downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG', 'separator',
              'downloadCSV', 'downloadXLS', 'viewData'
            ]
          }
        }
      },
      palette: { colorScheme: 'light' },
      chart: { style: { fontFamily: 'Helvetica, Arial, sans-serif' } },
      plotOptions: {
        line: { lineWidth: 1 },
        spline: { lineWidth: 1 },
        area: { lineWidth: 1, legendSymbol: 'rectangle' },
        solidgauge: {
          dataLabels: {
            style: { fontSize: '0.7em' },
            verticalAlign: 'top',
            borderWidth: 1,
            borderColor: '#cccccc',
            borderRadius: 3
          }
        }
      }
    });
  }
}
